'use strict';

let Selector = {
  passwordToggleButton: '.js-pwd-toggler',
  passwordInput: '.js-password-input'
};

let bindEvent = () => {
  $(Selector.passwordToggleButton).on('click', (e) => {
    togglePwd(e);
  });

  $(Selector.passwordToggleButton).on('keydown', (e) => {
    if (e.keyCode === 13) togglePwd(e);
  });
};

let ariaFor = (catalyst, isHidden) => {
  let data = $(catalyst).data();
  if (isHidden) {
    return data.showAria || (data.showLabel + ' password');
  }
  return data.hideAria || (data.hideLabel + ' password');
};

let togglePwd = (event) => {
  event.preventDefault();
  let catalyst = event.currentTarget;
  let target = $(catalyst).data().target;
  let label = $(catalyst).find('.js-show-label');

  if ($(target).attr('type') === 'password') {
    $(target).attr('type', 'text');
    $(label).text($(catalyst).data().hideLabel);
    $(catalyst).attr('aria-label', ariaFor(catalyst, false));
  } else {
    $(target).attr('type', 'password');
    $(label).text($(catalyst).data().showLabel);
    $(catalyst).attr('aria-label', ariaFor(catalyst, true));
  }
};

module.exports = function() {
  let $togglers = $(Selector.passwordToggleButton);
  if ($togglers.length) {
    bindEvent();
    $togglers.each(function() {
      $(this).attr('aria-label', ariaFor(this, true));
    });
  }
};
